import React from 'react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function SettingsLabelsPage() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const labels = data?.workspace?.navLabels || [];

  return (
    <MainPanel title={t('settingsPages.labelsTitle')} subtitle={t('settingsPages.labelsSubtitle')}>
      {labels.length === 0 ? (
        <div className="custio-empty" style={{ paddingTop: 24 }}>
          <p className="custio-empty__title">{t('settingsPages.labelsEmpty')}</p>
          <p style={{ fontSize: 14, margin: 0, color: '#9ca3af' }}>{t('settingsPages.labelsEmptyBody')}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {labels.map((l) => (
            <div
              key={l.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '12px 16px',
                background: '#1f2229',
                borderRadius: 10,
                border: '1px solid rgba(255,255,255,0.06)',
                color: '#f3f4f6',
              }}
            >
              <span className="custio-nav-link__dot" style={{ background: l.colorHex || '#6b7280' }} aria-hidden />
              <span style={{ fontWeight: 500 }}>{l.name}</span>
            </div>
          ))}
        </div>
      )}
    </MainPanel>
  );
}
